import type { InstructionIconKey } from "@/types/instruction-content";

/**
 * Icon tiles for the instruction moves.
 *
 * These live under `public/assets/icons/instructions` (not imported as
 * modules) the same way the result screen's stage icons are referenced by
 * URL string rather than bundled.
 */
export const INSTRUCTION_ICONS: Record<InstructionIconKey, string> = {
  tickCircle: "/assets/icons/instructions/tick-circle.svg",
  closeCircle: "/assets/icons/instructions/close-circle.svg",
  winner: "/assets/icons/instructions/winner.svg",
  danger: "/assets/icons/instructions/danger.svg",
};
